var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icons /  Webapp UI"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8681_138655",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8681_138655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "videocam",
    d: "M3.5 15.5C3.0875 15.5 2.7345 15.3533 2.441 15.0597C2.147 14.7657 2 14.4125 2 14V5C2 4.5875 2.147 4.2345 2.441 3.941C2.7345 3.647 3.0875 3.5 3.5 3.5H12.5C12.9125 3.5 13.2657 3.647 13.5597 3.941C13.8533 4.2345 14 4.5875 14 5V8.375L17 5.375V13.625L14 10.625V14C14 14.4125 13.8533 14.7657 13.5597 15.0597C13.2657 15.3533 12.9125 15.5 12.5 15.5H3.5ZM3.5 14H12.5V5H3.5V14Z",
    fill: "#1DA687"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoGreen);
export default __webpack_public_path__ + "static/media/video-green.9a9f36d22c3aafd8eed34b7eb4fd3d8f.svg";
export { ForwardRef as ReactComponent };